import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Chart, destroy } from 'chart.js/auto';
import moment from 'moment';
const baseUrl = '  https://drghis.mgmebuild.com/api/';

const PatVitalDetails = (props) => {
  const pat_id = localStorage.getItem('pat_id');
  const chartRef = useRef(null);
  const [rows, setRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [patientData, setPatientData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get(`${baseUrl}pat-search-view/${pat_id}/`);
        if (response1.status === 200 || response1.status === 201) {
          setPatientData(response1.data);
          const patId = response1.data[0].id;
          const response2 = await axios.get(`${baseUrl}pat-op-consult/${patId}/`);
          const opData = response2.data.map((data) => ({ ...data, type: 'op' }));
          const response6 = await axios.get(`${baseUrl}pat-op-consult/${patId}/`);
          const ipData = response6.data.map((data) => ({ ...data, type:'ip'}));
            setRows1(ipData);
          const combined = [...opData];
          setRows(combined);
        } else {
          window.location.href = '/pat-menu/';
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [pat_id]);


  const columns = [
    { field: 'add_date', headerName: 'Appt Date', width: 120 },
    { field: 'weight', headerName: 'Weight', width: 100 },
    { field: 'height', headerName: 'Hight', width: 100 },
    { field: 'bmi', headerName: 'BMI', width: 100 },
    { field: 'tempr', headerName: 'Tempr', width: 100 },
    { field: 'pulse', headerName: 'Pulse', width: 100 },
    { field: 'spo2', headerName: 'Spo2', width: 100 },
    { field: 'addedby', headerName: 'Added by', width: 100 },

  ];

      const columns1 = [
      { field: 'add_date', headerName: 'IP Date', width: 120 },
      { field: 'ip__ip_id', headerName: 'IP ID', width: 40 },
      { field: 'weight', headerName: 'Weight', width: 200 },
      { field: 'height', headerName: 'Hight', width: 200 },
      { field: 'bmi', headerName: 'BMI', width: 200 },
    ];

const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (chartRef.current && rows.length > 0) {
      const ctx = chartRef.current.getContext('2d');

      // Clear the canvas
      ctx.clearRect(0, 0, chartRef.current.width, chartRef.current.height);

      const bmiData = rows.map((row) => ({
        x: row.add_date,
        y: row.bmi,
      }));

      const temprData = rows.map((row) => ({
        x: row.add_date,
        y: row.tempr,
      }));

      const pulseData = rows.map((row) => ({
        x: row.add_date,
        y: row.pulse,
      }));

      const spo2Data = rows.map((row) => ({
        x: row.add_date,
        y: row.spo2,
      }));

      setChartData({
        bmi: bmiData,
        tempr: temprData,
        pulse: pulseData,
        spo2: spo2Data,
      });
    }
  }, [rows]);

  useEffect(() => {
    if (chartData && Object.keys(chartData).length > 0) {
      const ctx = chartRef.current.getContext('2d');

      // Clear the canvas
      ctx.clearRect(0, 0, chartRef.current.width, chartRef.current.height);

      const chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: rows.map((row) => row.add_date), // Display dates on the X-axis
          datasets: [
            {
              label: 'BMI',
              data: chartData.bmi,
              backgroundColor: 'rgba(75, 192, 192, 0.5)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
            {
              label: 'Tempr',
              data: chartData.tempr,
              backgroundColor: 'rgba(255, 99, 132, 0.5)',
              borderColor: 'rgba(255, 99, 132, 1)',
              borderWidth: 1,
            },
            {
              label: 'Pulse',
              data: chartData.pulse,
              backgroundColor: 'rgba(54, 162, 235, 0.5)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1,
            },
            {
              label: 'Spo2',
              data: chartData.spo2,
              backgroundColor: 'rgba(255, 206, 86, 0.5)',
              borderColor: 'rgba(255, 206, 86, 1)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            y: {
              title: {
                display: true,
                text: 'Values',
              },
            },
          },
        },
      });

      // Cleanup function
      return () => {
        chart.destroy(); // Destroy chart instance on unmount
      };
    }
  }, [chartData]);

  return (
    <section className="container mt-4">
      <div className="row table-responsive">
        <div className="col-md-12 col-12 mb-2">
          <table className="erp-table-modern">
            <thead>
              <tr style={{ backgroundColor: '#1bc5ce', color: 'white' }}>
                <th>Patient ID</th>
                <th>Patient Name</th>
                <th>Gender</th>
                <th>D.O.B/Age</th>
                <th>Mobile</th>
                <th>Regd. On</th>
              </tr>
            </thead>
            <tbody>
              {patientData.map((patientData, index) => (
                <tr key={index}>
                  <td>{patientData.pat_id}</td>
                  <td>{patientData.patient}</td>
                  <td>{patientData.gender}</td>
                  <td>{patientData.age}</td>
                  <td>{patientData.mobile}</td>
                  <td>{patientData.add_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div>
          <div style={{ height: '100%', width: '100%' }}>
          <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i> OP Vital Details</h3>
            <DataGrid
              className="mt-4"
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rows={rows}
              columns={columns}
              pageSize={10}
              slots={{ toolbar: GridToolbar }}
              autoHeight
            />
          </div>
          <div style={{ height: '100%', width: '100%' }}>
          <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
            aria-hidden="true" style={{color: 'red'}}></i> IP Vital Details</h3>
            <DataGrid
              className="mt-4"
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rows={rows1}
              columns={columns1}
              pageSize={10}
              slots={{ toolbar: GridToolbar }}
              autoHeight
            />
          </div>
          <div style={{ height: '100%', width: '100%' }}>
        <canvas ref={chartRef} />
      </div>
    </section>
  );
};

export default PatVitalDetails;
